module.exports = __webpack_public_path__ + "static/img/recall-de-campanha-produtos-existentes.a3e425cc.png";